import "./styles.css"

function Footer() {
  return (
    <footer className="background-0">
      <div className="center">
        Derechos Reservados &copy; 2022
      </div>
    </footer>
  );
}

export default Footer;
